import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faFileDownload } from "@fortawesome/sharp-regular-svg-icons";
import styles from "./download-agreement-button.module.scss";

type DownloadAgreementButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> & {
  children?: string;
};

export const DownloadAgreementButton = ({
  type,
  children = "Continue",
  className,
  ...props
}: DownloadAgreementButtonProps) => (
  <button
    type={type === "submit" ? "submit" : "button"}
    {...props}
    className={classNames(className, styles.DownloadAgreementButton)}
  >
    <div className={styles.icon}>
      <FontAwesomeIcon icon={faFileDownload} />
    </div>
    {children}
  </button>
);
